<template>
  <layout-main-inner title="商品">
    <el-button
      v-if="permission.LVL2"
      slot="action"
      type="primary"
      @click="selectVendor">
      新增商品
    </el-button>
    <layout-card-wrap :hasSlot="true">
      <template slot="form">
        <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" />
        <el-input
          v-model="config.productName"
          clearable
          style="width: 240px"
          placeholder="请输入商品名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="商品名称"
          min-width="200"
          prop="productName"> </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="130"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="所属机构"
          prop="sgsName"
          min-width="160"
        ></el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          label="操作"
          width="150">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-modal
      ref="edit"
      :callback="
        () => {
          handleCurrentChange(1)
        }
      "
    />
    <add-modal
      ref="add"
      :callback="
        () => {
          handleCurrentChange(1)
        }
      "
    />
    <vendor-select-modal
      ref="vendor"
      :autoClose="false"
      :callback="additem" />
  </layout-main-inner>
</template>
<script>
import EditModal from './editModal.vue'

import { mapState } from 'vuex'
import VendorSelectModal from './vendor-select-modal.vue'
import EntAutoSelect from '../../components/ent-auto-select.vue'
import AddModal from './add-modal.vue'
export default {
  name: 'ProductsIndex',
  components: { EditModal, VendorSelectModal, EntAutoSelect, AddModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    selectVendor() {
      this.$refs.vendor.fetch()
    },
    updateitem(row) {
      this.$refs.edit.init(row)
    },
    additem(row) {
      const { vendorId, vendorName } = row
      this.$refs.add.init({ vendorId, vendorName })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteproduct', {
          payload: {
            productId: row.productId,
            vendorId: row.vendorId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getproducts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
